module.exports = __webpack_public_path__ + "static/media/kc4.83df1bc5.png";